/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', () => {
    setupDisclosureWidgets('header');
    setupDisclosureWidgets('sidebar');
});

function setupDisclosureWidgets(type) {
    const disclosureElements = document.querySelectorAll(`.disclosure-${type}`);
    const disclosureForm = document.getElementById(`localization_form${type}`);

    if (!disclosureForm) {
        console.warn('Form element not found for:', type);
        return;
    }

    disclosureElements.forEach(disclosure => {
        setupDisclosure(disclosure, disclosureForm, type);
    });
}

function setupDisclosure(disclosure, form, type) {
    const disclosureToggle = disclosure.querySelector(`[data-disclosure-toggle-${type}]`);
    const disclosureInput = form.querySelector(`[data-disclosure-input-${type}]`);
    const disclosureOptions = document.querySelectorAll(`[data-disclosure-option-${type}]`);
    const disclosureModal = document.getElementById('countrycheck');

    if (!disclosureToggle) {
        console.warn('Required elements not found for:', disclosure);
        return;
    }

    const toggleList = () => {
        const ariaExpanded = disclosureToggle.getAttribute('aria-expanded') === 'true';
        disclosureModal.classList.toggle('active');
        document.body.classList.toggle('modal-open', !ariaExpanded);
        disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
    };

    const connectOptions = (event) => {
        event.preventDefault();
        if (disclosureInput) {
            disclosureInput.value = event.currentTarget.dataset.value;
            form.submit();
        }
    };

    disclosureToggle.addEventListener('click', toggleList);
    disclosureOptions.forEach(option => {
        option.addEventListener('click', connectOptions);
    });

    // Improved body click handler
    document.addEventListener('click', (event) => {
        if (!disclosure.contains(event.target) && disclosureModal.classList.contains('active')) {
            toggleList();
        }
    }, { capture: true });
}
